import { JSX, SVGProps } from 'react';

export const Cloudflare = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={47}
    height={56}
    viewBox="0 0 47 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.3524 6.40918H45.0088L46.8092 8.20953V47.8173L45.0088 49.6177H27.7615L28.6346 48.2674H44.4507L45.4589 47.2592V8.76764L44.4507 7.75944H33.5406L32.2533 14.4118H30.8761L32.1093 7.69643L32.3614 6.40918H32.3524ZM1.80035 49.6177L0 47.8173V8.20953L1.80035 6.40918H19.7139L18.8137 7.75944H2.35846L1.35027 8.76764V47.2592L2.35846 48.2674H15.393L15.177 49.6177H1.80035ZM4.50088 45.1168H12.1524L11.8823 46.467H3.60071L3.15062 46.017V37.9154L4.50088 40.6159V45.1168ZM35.1069 45.1168L36.4572 46.467H29.7058L30.606 45.1168H35.1069Z"
      fill="#B7BBBD"
    />
    <path
      d="M20.4069 33.4146H8.10147L6.60718 30.606L27.3112 0L30.5699 1.35027L26.4831 22.6124H38.7075L40.2198 25.394L20.4159 56L17.1212 54.7398L20.4069 33.4146ZM4.95085 12.7105C4.59274 12.7105 4.24929 12.5682 3.99607 12.315C3.74285 12.0618 3.60059 11.7183 3.60059 11.3602C3.60059 11.0021 3.74285 10.6587 3.99607 10.4054C4.24929 10.1522 4.59274 10.01 4.95085 10.01C5.30896 10.01 5.65241 10.1522 5.90563 10.4054C6.15886 10.6587 6.30112 11.0021 6.30112 11.3602C6.30112 11.7183 6.15886 12.0618 5.90563 12.315C5.65241 12.5682 5.30896 12.7105 4.95085 12.7105ZM8.55156 12.7105C8.19345 12.7105 7.85 12.5682 7.59678 12.315C7.34355 12.0618 7.20129 11.7183 7.20129 11.3602C7.20129 11.0021 7.34355 10.6587 7.59678 10.4054C7.85 10.1522 8.19345 10.01 8.55156 10.01C8.90967 10.01 9.25312 10.1522 9.50634 10.4054C9.75956 10.6587 9.90182 11.0021 9.90182 11.3602C9.90182 11.7183 9.75956 12.0618 9.50634 12.315C9.25312 12.5682 8.90967 12.7105 8.55156 12.7105ZM12.1523 12.7105C11.7942 12.7105 11.4507 12.5682 11.1975 12.315C10.9443 12.0618 10.802 11.7183 10.802 11.3602C10.802 11.0021 10.9443 10.6587 11.1975 10.4054C11.4507 10.1522 11.7942 10.01 12.1523 10.01C12.5104 10.01 12.8538 10.1522 13.107 10.4054C13.3603 10.6587 13.5025 11.0021 13.5025 11.3602C13.5025 11.7183 13.3603 12.0618 13.107 12.315C12.8538 12.5682 12.5104 12.7105 12.1523 12.7105Z"
      fill="url(#paint0_linear_10277_31302)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10277_31302"
        x1={2253.98}
        y1={-83.262}
        x2={-789.115}
        y2={2222.66}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBB743" />
        <stop offset={1} stopColor="#EA6B00" />
      </linearGradient>
    </defs>
  </svg>
);
